const colors = {
  success: {
    background: "#56f000",
    text: "#FFFFFF",
  },
  standby: {
    background: "#1976d2",
    text: "#FFFFFF",
  },
  warning: {
    background: "#d6c214",
    text: "#FFFFFF",
  },
  danger: {
    background: "#ff3838",
    text: "#FFFFFF",
  },
  off: {
    background: "#ebebe0",
    text: "#FFFFFF",
  },
};

export const institutionalColors = {
  pbBlue: "#3B89C7",
  pbYellow: "#F6EE81",
  pbFontGray: "#717171",
  pbFontGrayLight: "#878787",
  pbFontGrayDark: "#555555",
  pbFontGrayWatermark: "#A8A8A8",
};

export default colors;
